<template>
  <div class="login-page">
    <!-- 顶部欢迎区域 -->
    <div class="login-header">
      <div class="brand">
        <div class="brand-name">HQS</div>
        <div class="brand-desc">AUTOMOTIVE</div>
      </div>
      <div class="welcome-text">Welcome Back</div>
    </div>

    <!-- 登录表单区域 -->
    <div class="login-form-container">
      <van-form
        @submit="onLogin"
        @keyup.enter.native="onLogin"
        class="login-form"
      >
        <!-- 用户名输入 -->
        <van-field
          v-model="loginForm.userName"
          name="userName"
          label="Account"
          placeholder="Enter your username"
          :rules="[{ required: true, message: 'The username cannot be empty' }]"
          clearable
          autocomplete="off"
        />

        <!-- 密码输入 -->
        <van-field
          v-model="loginForm.password"
          type="password"
          name="password"
          label="Password"
          placeholder="Enter your password"
          :rules="[{ required: true, message: 'Password cannot be empty' }]"
          clearable
          show-password
          autocomplete="off"
        />

        <!-- 登录按钮 -->
        <van-button
          type="primary"
          round
          block
          class="login-btn"
          :loading="isLogin"
          native-type="submit"
        >
          {{ isLogin ? "Logging in..." : "Login" }}
        </van-button>
      </van-form>
    </div>

    <!-- 底部区域 -->
    <div class="login-footer">
      <!-- <p class="copyright">© 2025 HQS Automotive. All rights reserved.</p> -->
    </div>
  </div>
</template>

<script>
import objurl from "@/common/interface/url.js";
import objaxios from "axios";
import objstorage from "@/common/localstorage/storage.js";

export default {
  name: "MobileLogin",
  data() {
    return {
      isLogin: false,
      loginForm: {
        userName: "",
        password: ""
      }
    };
  },
  created() {
    // 调试用账号密码，发布需注释
    // this.loginForm.userName = "Xinquan";
    // this.loginForm.password = "string";
   // this.loginForm.userName = "nevada@tesla.com";
  //  this.loginForm.password = "zavpVWAf";
  // this.loginForm.userName = "QI@TESLA.com";
  // this.loginForm.password = "sVYPiE8n";
  },
  methods: {
    onLogin() {
      this.isLogin = true;
      const _this = this;

      // 清除默认Authorization头
      objaxios.defaults.headers.common["Authorization"] = "";

      objaxios
        .post(objurl.user_login_mobile, {
          username: this.loginForm.userName,
          password: this.loginForm.password
        })
        .then(function(res) {
          _this.isLogin = false;
          if (res.data.code === "200") {
            try {
              objstorage.set("userinfo", res.data.data);
              _this.$router.replace("/index-mobile"); // 建议为手机端设置单独的首页路由
            } catch (e) {
              console.error("Storage error:", e);
              _this.$toast("Login failed, please try again");
            }
          } else {
            _this.$toast(res.data.message || "Login failed");
          }
        })
        .catch(function(error) {
          _this.isLogin = false;
          console.error("Login error:", error);
          _this.$toast("Network error, please try again");
        });
    }
  }
};
</script>

<style lang="stylus" scoped>
.login-page {
  min-height: 100vh;
  background-color: #f5f7fa;
  padding: 0 16px;
  box-sizing: border-box;
  display: flex;
  flex-direction: column;
}

.login-header {
  padding-top: 80px;
  padding-bottom: 40px;
  text-align: center;

  .brand {
    margin-bottom: 20px;

    .brand-name {
      font-size: 32px;
      font-weight: bold;
      color: #2a4062;
    }

    .brand-desc {
      font-size: 14px;
      color: #606266;
      margin-top: 4px;
      letter-spacing: 1px;
    }
  }

  .welcome-text {
    font-size: 20px;
    color: #303133;
    font-weight: 500;
  }
}

.login-form-container {
  flex: 1;
  display: flex;
  flex-direction: column;
}

.login-form {
  background-color: #fff;
  padding: 24px 16px;
  border-radius: 12px;
  box-shadow: 0 2px 10px rgba(0, 0, 0, 0.05);

  /deep/ .van-cell {
    padding: 12px 0;
    border-bottom: 1px solid #f2f3f5;

    &:last-child {
      border-bottom: none;
    }
  }

  /deep/ .van-field__label {
    width: 70px;
    color: #606266;
    font-size: 14px;
  }

  /deep/ .van-field__control {
    font-size: 15px;
  }
}

.login-btn {
  margin-top: 30px;
  height: 48px;
  line-height: 48px;
  font-size: 16px;
  background-color: #2a4062;
  border: none;

  &:active {
    background-color: #1e304a;
  }
}

.login-footer {
  padding: 20px 0;
  text-align: center;

  .copyright {
    font-size: 12px;
    color: #909399;
    margin: 0;
  }
}

/* 适配小屏手机 */
@media (max-width: 320px) {
  .login-header {
    padding-top: 60px;
  }

  .brand-name {
    font-size: 28px !important;
  }
}

/* 适配大屏手机 */
@media (min-width: 414px) {
  .login-form {
    padding: 30px 20px;
  }

  .login-header {
    padding-top: 100px;
  }
}
</style>


// WEBPACK FOOTER //
// src/views/LoginMobile.vue